import { Router, CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { environment } from "src/environments/environment";
import { HankoService } from "../../sopi/hanko";


export const IsAuthenticatedGuard: CanActivateFn = () => {
    const router = inject(Router);
    const hanko = inject(HankoService);

    try {
        const isLoggedIn = hanko.isLoggedIn;
        console.log(`authguard: isLoggedIn: ${isLoggedIn}`);
        // const isLoggedIn = await hanko.checkIsLoggedIn();

        if (!isLoggedIn) {
            return router.parseUrl(environment.loginRoute);
        }

        return true;
    } catch (error) {
        console.error('AuthGuard error:', error);
        return router.parseUrl('/');
    }
};


// @Injectable()
// export class IsAuthenticatedGuard implements CanActivate {

//     constructor(private hanko: HankoService, private _router: Router) {

//         if (!environment.loginRoute) {
//             throw new Error("Login route has not been configured.");
//         }
//     }

//     public async canActivate(
//         route: ActivatedRouteSnapshot,
//         state: RouterStateSnapshot
//     ): Promise<boolean> {

//         try {

//             const token = this.hanko.getAccessToken();

//             if (!token) {

//                 await this._router.navigate([environment.loginRoute], {
//                     queryParams: {
//                         redirectTo: state.url
//                     }
//                 });

//                 return false;
//             }

//             await this.hanko.validateSession();

//         } catch (error) {
//             console.error('AuthGuard error:', error);

//             await this._router.navigate([environment.loginRoute], {
//                 queryParams: {
//                     redirectTo: state.url
//                 }
//             });

//             return false;
//         }


//         return true;
//     }
// }
